// src/lib/useEchapPourFermer.js — Échap ferme la modale (consigne Dimitri
// 2026-08-14 : « partout où il y a une modale », née de la QA Suivi équipe où
// ni Durée ni Intervention ne répondaient au clavier).
//
// ⚠️ UNE PILE, PAS UN LISTENER NU : deux modales empilées (une modale qui
// ouvre une confirmation) partagent le même événement window — sans pile,
// UN Échap fermerait les deux d'un coup. Ici seule la DERNIÈRE ouverte
// répond ; l'Échap suivant ferme la précédente.
//
// Usage : useEchapPourFermer(onFermer) — ou useEchapPourFermer(onFermer, ouvert)
// quand le composant reste monté modale fermée.

import { useEffect } from 'react'

const pile = []

export default function useEchapPourFermer(onFermer, actif = true) {
  useEffect(() => {
    if (!actif || typeof onFermer !== 'function') return undefined
    const jeton = {}
    pile.push(jeton)
    const ecoute = (e) => {
      if (e.key !== 'Escape') return
      if (pile[pile.length - 1] !== jeton) return
      onFermer()
    }
    window.addEventListener('keydown', ecoute)
    return () => {
      const i = pile.indexOf(jeton)
      if (i !== -1) pile.splice(i, 1)
      window.removeEventListener('keydown', ecoute)
    }
  }, [actif, onFermer])
}
